<template>
    <v-row class="mx-n2">
        <v-col cols="6" class="pa-2">
            <v-text-field :label="startsAt.text" v-model="value[startsAt.value]" type="date" v-bind="inputProps" />
        </v-col>
        <v-col cols="6" class="pa-2">
            <v-text-field :label="endsAt.text" v-model="value[endsAt.value]" type="date" v-bind="inputProps" />
        </v-col>
    </v-row>
</template>

<script>
const inputProps = {
    "hide-details": true,
    persistentPlaceholder: true,
    outlined: true,
    dense: true,
};
export default {
    props: {
        value: Object,
        isApplicationDates: { type: Boolean, default: false },
    },
    computed: {
        category() {
            return this.value.category;
        },
        map() {
            if (this.isApplicationDates) {
                return {
                    startsAt: { text: "신청기간(시작일)", value: "applicationStartsAt" },
                    endsAt: { text: "신청기간(종료일)", value: "applicationEndsAt" },
                };
            } else {
                return {
                    startsAt: { text: "지원기간(시작일)", value: "serviceStartsAt" },
                    endsAt: { text: "지원기간(종료일)", value: "serviceEndsAt" },
                };
            }
        },
        startsAt() {
            return this.map.startsAt;
        },
        endsAt() {
            return this.map.endsAt;
        },
    },
    data() {
        return { inputProps };
    },
};
</script>

<style></style>
